<template>
    <div class="container-fluid position-relative bg-BAT">
        <loading v-if="loading !== 0"></loading>
        <div>
            <div class="container watch-container py-4">
                <div>
                    <div class="breadcrumbs-retos d-flex flex-column pb-2">
                        <div>
                            <a href="/home-bat">
                                <img src="/img/icons/homeBread.svg" alt="" />
                                Home
                            </a>
                            <a id="practica" class="link cursor-pointer link-active-bread" :href="'/get-pdv-details/' + pdv.id">Staff</a>
                            <span id="optionP" class="d-none color-active-miga"></span>
                        </div>
                    </div>
                    <a class="pb-2 pt-2" :href="'/get-pdv-details/' + pdv.id"><img src="/img/icons/regresar.svg" alt="icon"></a>
                </div>
            </div>

            <div class="container mt-3">
                <div class="row align-items-start">
                    <div class="col-12 col-md-6">
                        <div class="header-portfolio d-flex flex-column">
                            <h5 class="text-title-bat mb-2">{{ type === 'send' ? 'Transferir usuario': 'Solicitar usuario'  }}</h5>
                        </div>
                    </div>
                </div>

                <div class="content-update">
                    <div class="form-cart mt-4">
                        <div>
                            <!-- Paso 1: Input de identificación -->
                            <div v-if="type === 'send'">
                                <form class="row g-3">
                                    <div class="col-12 col-md-6">
                                        <div class="mb-3">
                                            <label for="codeInsitu">Código insitu destino</label>
                                            <input type="text" id="codeInsitu" v-model="codeInsitu" class="form-control" placeholder="Ingresa el código insitu" autocomplete="off" :class="{'border-red': !codeInsitu}" style="border-width: 1.5px;" @input="validateNumberInput"/>
                                        </div>
                                    </div>

                                    <!-- Botón de validación -->
                                    <div class="d-flex justify-content-start boton">
                                        <button class="mx-1 btn btnBlue text-title-bat rounded-3 cursor-pointer btn-created-staff" :disabled="!codeInsitu" :class="{'btnBlue': codeInsitu, 'btn-secondary': !codeInsitu}" type="button" @click="validateIdentification">
                                           Solicitar transferencia
                                        </button>
                                    </div>
                                </form>
                            </div>
                            <div v-else>
                                <form class="row g-3">
                                    <div class="col-12 col-md-12">
                                        <el-alert
                                            type="warning"
                                            :closable="false"
                                            class="custom-alert-staff-no-quotas"
                                            show-icon
                                        >
                                            <div class="text-bat">
                                                La solicitud de staff aplica únicamente para realizar una transferencia de un usuario staff existente y activo a otro punto de venta.
                                            </div>
                                        </el-alert>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="mb-3">
                                            <label for="identification">Número de identificación</label>
                                            <input type="text" id="identification" v-model="identification" class="form-control" placeholder="Ingresa su número identificación" autocomplete="off" :class="{'border-red': !identification}" style="border-width: 1.5px;" @input="validateNumberInput"/>
                                        </div>
                                    </div>

                                    <!-- Botón de validación -->
                                    <div class="d-flex justify-content-start boton">
                                        <button class="mx-1 btn btnBlue text-title-bat rounded-3 cursor-pointer btn-created-staff" :disabled="!identification" :class="{'btnBlue': identification, 'btn-secondary': !identification}" type="button" @click="validateIdentification">
                                            Solicitar transferencia
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog :visible.sync="modalConfirmTransfer" :width="getWidth()"
                   style="width: 75% !important; z-index: 2001; margin: 0 auto 50px !important;"
                   class="dialog-mobile" :close-on-click-modal="false" :close-on-press-escape="false"
                   :show-close="true">
            <div class="row">
                <div class="col-12">
                    <div class="d-flex flex-column align-items-center text-center">
                        <img src="/img-version2/icons/staff/user-tick.svg" alt="Icono" class="mb-2">
                        <h6 class="mx-auto" style="width: auto!important; max-width: 268px!important;">
                            {{ this.titleModalTransfer }}
                        </h6>
                        <p class="text-bat px-0" v-if="type === 'send'">
                            {{ this.descriptionModalTransfer }}
                        </p>
                        <div v-if="type !== 'send'" v-html="descriptionModalTransfer"></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12" style="padding-top: 10px !important;">
                    <div class="d-flex flex-column align-items-center text-center">
                        <a  @click="sendTransfer" class="text-decoration-none">
                            <button :disabled="isSending" class="w-100" :class="{'btn-disabled-staff': isSending, 'btn': true, 'rounded-3': true, 'bg-transparent': true, 'p-2': true, 'px-3': true, 'mt-3': true, 'text-bat': true, 'align-items-center': true, 'btn-popups': true, 'text-indigo': true, 'fw-bold': true, 'd-block': true, 'd-md-inline-block': true}"
                            >Aceptar</button>
                        </a>
                    </div>
                </div>
                <div class="col-12">
                    <div class="d-flex flex-column align-items-center text-center">
                        <div class="text-more cursor-pointer buttonOne " type="buttoNot"
                             @click="modalConfirmTransfer = false">Cancelar
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="modalRejectTransferByUser" :width="getWidth()"
            style="width: 75% !important; z-index: 2001; margin: 0 auto 50px !important;" class="dialog-mobile"
            :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true"  @close="exitModalReject">
            <div class="modals modal-staff">
                <img src="/img-version2/icons/group.svg" alt="Icono">
                <h6 class="mx-auto text-title-bat" style="width: auto!important; max-width: 268px!important;">No podemos hacer esta transferencia</h6>
                <p class="text-bat px-0">{{ messageError }}</p>
            </div>
            <div class="row">
                <div class="col-12" style="padding-top: 10px !important;">
                    <div class="d-flex flex-column align-items-center text-center">
                        <a  @click="exitModalReject" class="text-decoration-none">
                            <button class="w-100" :class="{'btn': true, 'rounded-3': true, 'bg-transparent': true, 'p-2': true, 'px-3': true, 'mt-3': true, 'text-bat': true, 'align-items-center': true, 'btn-popups': true, 'text-indigo': true, 'fw-bold': true, 'd-block': true, 'd-md-inline-block': true}"
                            >Aceptar</button>
                        </a>
                    </div>
                </div>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="modalRejectTransferByInsitu" :width="getWidth()"
                   style="width: 75% !important; z-index: 2001; margin: 0 auto 50px !important;" class="dialog-mobile"
                   :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true" @close="exitModalReject">
            <div class="modals modal-staff">
                <img src="/img-version2/icons/group.svg" alt="Icono">
                <h6 class="mx-auto text-title-bat" style="width: auto!important; max-width: 268px!important;">No podemos hacer esta transferencia</h6>
                <p class="text-bat px-0">{{ messageError }} </p>
            </div>
            <div class="row">
                <div class="col-12" style="padding-top: 10px !important;">
                    <div class="d-flex flex-column align-items-center text-center">
                        <a  @click="exitModalReject" class="text-decoration-none">
                            <button class="w-100" :class="{'btn': true, 'rounded-3': true, 'bg-transparent': true, 'p-2': true, 'px-3': true, 'mt-3': true, 'text-bat': true, 'align-items-center': true, 'btn-popups': true, 'text-indigo': true, 'fw-bold': true, 'd-block': true, 'd-md-inline-block': true}"
                            >Aceptar</button>
                        </a>
                    </div>
                </div>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="modalTransferTwentyDays" :width="getWidth()"
                   style="width: 75% !important; z-index: 2001; margin: 0 auto 50px !important;" class="dialog-mobile"
                   :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true" @close="exitModalReject">
            <div class="modals modal-staff">
                <img src="/img-version2/icons/staff/user-add.svg" alt="Icono">
                <h6 class="mx-auto text-title-bat" style="width: auto!important; max-width: 268px!important;">Transferencias no disponibles por ahora</h6>
                <p class="text-bat px-0">Las transferencias de usuario solo se realizan hasta el día 20 de cada mes. Podrás solicitarlas nuevamente en el próximo periodo. </p>
            </div>
            <div class="row">
                <div class="col-12" style="padding-top: 10px !important;">
                    <div class="d-flex flex-column align-items-center text-center">
                        <a  @click="exitModalReject" class="text-decoration-none">
                            <button class="w-100" :class="{'btn': true, 'rounded-3': true, 'bg-transparent': true, 'p-2': true, 'px-3': true, 'mt-3': true, 'text-bat': true, 'align-items-center': true, 'btn-popups': true, 'text-indigo': true, 'fw-bold': true, 'd-block': true, 'd-md-inline-block': true}"
                            >Aceptar</button>
                        </a>
                    </div>
                </div>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="modalTransferPrevious" :width="getWidth()"
                   style="width: 75% !important; z-index: 2001; margin: 0 auto 50px !important;" class="dialog-mobile"
                   :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true" @close="exitModalReject">
            <div class="modals modal-staff">
                <img src="/img-version2/icons/staff/user-add.svg" alt="Icono">
                <h6 class="mx-auto text-title-bat" style="width: auto!important; max-width: 268px!important;">Aún no puedes transferir a este usuario</h6>
                <p class="text-bat px-0">{{ messageError }} </p>
            </div>
            <div class="row">
                <div class="col-12" style="padding-top: 10px !important;">
                    <div class="d-flex flex-column align-items-center text-center">
                        <a  @click="exitModalReject" class="text-decoration-none">
                            <button class="w-100" :class="{'btn': true, 'rounded-3': true, 'bg-transparent': true, 'p-2': true, 'px-3': true, 'mt-3': true, 'text-bat': true, 'align-items-center': true, 'btn-popups': true, 'text-indigo': true, 'fw-bold': true, 'd-block': true, 'd-md-inline-block': true}"
                            >Aceptar</button>
                        </a>
                    </div>
                </div>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="modalTransferUserInactive" :width="getWidth()"
                   style="width: 75% !important; z-index: 2001; margin: 0 auto 50px !important;" class="dialog-mobile"
                   :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true" @close="exitModalReject">
            <div class="modals modal-staff">
                <img src="/img-version2/icons/staff/user-remove.svg" alt="Icono">
                <h6 class="mx-auto text-title-bat" style="width: auto!important; max-width: 268px!important;">Usuario Inactivo</h6>
                <p class="text-bat px-0">{{ messageError }} </p>
            </div>
            <div class="row">
                <div class="col-12" style="padding-top: 10px !important;">
                    <div class="d-flex flex-column align-items-center text-center">
                        <a  @click="exitModalReject" class="text-decoration-none">
                            <button class="w-100" :class="{'btn': true, 'rounded-3': true, 'bg-transparent': true, 'p-2': true, 'px-3': true, 'mt-3': true, 'text-bat': true, 'align-items-center': true, 'btn-popups': true, 'text-indigo': true, 'fw-bold': true, 'd-block': true, 'd-md-inline-block': true}"
                            >Aceptar</button>
                        </a>
                    </div>
                </div>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="modalTransferNoQuota" :width="getWidth()"
                   style="width: 75% !important; z-index: 2001; margin: 0 auto 50px !important;" class="dialog-mobile"
                   :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true" @close="exitModalReject">
            <div class="modals modal-staff">
                <img src="/img-version2/icons/staff/user-remove.svg" alt="Icono">
                <h6 class="mx-auto text-title-bat" style="width: auto!important; max-width: 268px!important;">No tienes cupos disponibles</h6>
                <p class="text-bat px-0">{{ messageError }} </p>
            </div>
            <div class="row">
                <div class="col-12" style="padding-top: 10px !important;">
                    <div class="d-flex flex-column align-items-center text-center">
                        <a  @click="exitModalReject" class="text-decoration-none">
                            <button class="w-100" :class="{'btn': true, 'rounded-3': true, 'bg-transparent': true, 'p-2': true, 'px-3': true, 'mt-3': true, 'text-bat': true, 'align-items-center': true, 'btn-popups': true, 'text-indigo': true, 'fw-bold': true, 'd-block': true, 'd-md-inline-block': true}"
                            >Aceptar</button>
                        </a>
                    </div>
                </div>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="modalNoAdminInPdv" :width="getWidth()"
                   style="width: 75% !important; z-index: 2001; margin: 0 auto 50px !important;" class="dialog-mobile"
                   :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true" @close="exitModalReject">
            <div class="modals modal-staff">
                <img src="/img-version2/icons/staff/user-remove.svg" alt="Icono">
                <h6 class="mx-auto text-title-bat" style="width: auto!important; max-width: 268px!important;">No podemos hacer esta transferencia</h6>
                <p class="text-bat px-0">{{ messageError }} </p>
            </div>
            <div class="row">
                <div class="col-12" style="padding-top: 10px !important;">
                    <div class="d-flex flex-column align-items-center text-center">
                        <a  @click="exitModalReject" class="text-decoration-none">
                            <button class="w-100" :class="{'btn': true, 'rounded-3': true, 'bg-transparent': true, 'p-2': true, 'px-3': true, 'mt-3': true, 'text-bat': true, 'align-items-center': true, 'btn-popups': true, 'text-indigo': true, 'fw-bold': true, 'd-block': true, 'd-md-inline-block': true}"
                            >Aceptar</button>
                        </a>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>

export default {
    props:{
        client_id:{
            default: null
        },
        pdv: {
            default: null
        },
        client: {
            default: null
        },
        type: {
            default: 'send'
        }
    },
    data() {
        return {
            loading: 0,
            codeInsitu: "",
            identification: "",
            isValidated: false,
            modalConfirmTransfer: false,
            titleModalTransfer: "",
            descriptionModalTransfer: "",
            pdvNew: null,
            userNew: null,
            modalRejectTransferByUser: false,
            modalRejectTransferByInsitu: false,
            modalTransferTwentyDays: false,
            modalTransferPrevious: false,
            modalTransferUserInactive: false,
            modalTransferNoQuota: false,
            modalNoAdminInPdv: false,
            messageError: "",
            isSending: false,
        };
    },

    mounted() {

    },

    methods: {

        validateIdentification() {
            const today = new Date();
            const day = today.getDate();

            if (day > 20) {
                this.modalTransferTwentyDays = true;
                return;
            }


            const value = (this.type === 'send') ? this.codeInsitu : this.identification;
            const route = (this.type === 'send') ? '/request-transfer-validate-pdv' : '/request-transfer-validate-user';

            const data = {
                identification_number:  (this.type === 'send') ? this.client.identification_number : this.identification,
                insitu_code:  (this.type === 'send') ? this.codeInsitu : this.pdv.insitu_code,
            };

            this.isValidated = false;
            this.loading = 1;


            axios.post(route, data)
            .then(response => {
                console.log(response);
                this.loading = 0;
                this.isValidated = true;

                if (response.status === 201) {
                    console.log(response.data);
                    if(this.type === 'send'){
                        this.pdvNew = response.data.pdv;
                        this.titleModalTransfer = `¿Deseas transferir a ${this.client.user.name} a ${this.pdvNew.name_pdv}-${this.pdvNew.address_pdv}?`;
                        this.descriptionModalTransfer = 'Al aceptar enviaremos la solicitud de transferencia al administrador de la tienda.';
                    }else{
                        this.userNew = response.data;
                        this.titleModalTransfer =  `¿Deseas solicitar a ${this.userNew.client.user.name} a tu staff?`;
                        const name_pdv = this.userNew.origin_pdv.name_pdv ?? 'Sin asignar';
                        const address_pdv = this.userNew.origin_pdv.address_pdv ?? 'Sin asignar';
                        if(this.userNew.admin === null){
                            this.modalNoAdminInPdv = true;
                            return;
                        }
                        const name_admin = this.userNew.admin.user?.name ?? 'No encontrado';

                        this.descriptionModalTransfer =  `<p class="text-bat px-0 mb-0">Tienda origen</p>
                            <p class="text-bat px-0 mb-0"><strong>${name_pdv}</strong>  </p>
                            <p class="text-bat px-0 mb-1"> <strong>${address_pdv}</strong> </p>
                            <p class="text-bat px-0 mb-0">Administrador </p>
                            <p class="text-bat px-0 mb-1"><strong>${name_admin}</strong> </p>
                            <p class="text-bat px-0 mb-0"> Al aceptar enviaremos la solicitud de transferencia a su administrador actual</p>`;
                    }
                    this.modalConfirmTransfer = true;
                }
            })
            .catch(error => {
                this.loading = 0;
                this.isValidated = true;

                this.messageError = error.response?.data?.message || 'Error inesperado';

                console.log(error.response);

                if(this.messageError === 'El usuario que deseas transferir no se encuentra activo.'){
                    this.modalTransferUserInactive = true;
                    return;
                }
                if(this.messageError === 'Un usuario debe estar mínimo 30 días en un punto de venta antes de solicitar su transferencia.'){
                    this.modalTransferPrevious = true;
                    return;
                }
                if(this.messageError === 'Tu punto de venta no tiene cupos para solicitar esta transferencia.' || this.messageError === 'El punto de venta destino no tiene cupos para realizar esta transferencia.'){
                    this.modalTransferNoQuota = true;
                    return;
                }
                if(this.type === 'send'){
                   this.modalRejectTransferByInsitu = true;
                }else{
                   this.modalRejectTransferByUser =  true;
                }

            })
            .finally(() => {
                this.loading = 0;
            });
        },

        validateNumberInput() {
            if(this.type === 'send'){
                this.codeInsitu = this.codeInsitu.replace(/[^0-9]/g, '');
            }else{
                this.identification = this.identification.replace(/[^0-9]/g, '');
            }

        },
        getWidth() {
            if (this.$mq === 'sm') {
                return '95%';
            } else if (this.$mq === 'md') {
                return '35%';
            } else if (this.$mq === 'lg') {
                return '30%';
            } else {
                return '20%';
            }
        },
        exitModalReject(){
          this.modalRejectTransferByUser = false;
          this.modalRejectTransferByInsitu = false;
          this.modalTransferTwentyDays = false;
          this.modalTransferPrevious = false;
          this.modalTransferUserInactive = false;
          this.modalTransferNoQuota = false;
          this.modalNoAdminInPdv = false;
          this.codeInsitu = '';
          this.identification = '';
          this.messageError = '';
        },
        sendTransfer(){
            if(this.isSending) return;
            this.isSending = true;
            axios.post('/send-request-transfer', {
                    identification_number : (this.type === 'send') ? this.client.identification_number : this.identification,
                    origin_insitu_code: (this.type === 'send') ? this.pdv.insitu_code : this.userNew.origin_pdv.insitu_code,
                    destination_insitu_code: (this.type === 'send') ? this.pdvNew.insitu_code : this.pdv.insitu_code,
                    type: (this.type === 'send') ? 'send' : 'request'
                })
                .then((response) => {
                    window.location.href = `/staff-transfers/${this.pdv.id}?type=send`;
                })
                .catch(error => {
                    console.log(error);
                });
        },
    }
}
</script>
